import React from "react";

export default function PopUpWin({ children  , buttonTxt, clickFunction, showWin}) {
  

  return (
    <div>
      {showWin && (
        <div className="popupOuter">
        <div className="popupwin">
          {/* <h1>{heading}</h1> */}
   
          {/* <p>{txt}</p> */}
          <div>{children}</div>

          <button className="button" onClick={clickFunction}>{buttonTxt}</button>
        </div>
        </div>
      )}
    </div>
  );
}


